// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> amc-preferred-theme-preferred -> bull-mountain-heights
// Generated: 2026-10-08T21:26:26.893Z
// Counts: 1 design, 77 content, 41 slot group, 6 collection binding, 7 section, 1 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Availability and Pricing</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h1><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h1><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Discover a convenient location at Bull Mountain Heights Apartments in Tigard, OR, where shopping, dining, parks, and everyday essentials are all within easy reach. Located along SW Bull Mountain Road, our community provides a convenient starting point for exploring Tigard, Beaverton, and the greater Portland area. Just minutes from the 79-acre riverside Cook Family Park and Washington Square Mall.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore <span data-type=\"field-token\" data-field=\"property_address_city\"></span> and the Surrounding Area</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-loader.javascript_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_apartmentsync_javascript_id"
  },
  "apply-now-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to make <span data-type=\"field-token\" data-field=\"property_name\"></span> your new home? Start your application online to take the next step toward finding an apartment that fits your needs. Complete the application below to get started.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.site_hash": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "the",
    "generatedValue": null,
    "mappedField": "custom_audioeye_site_hash"
  },
  "feeguide.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Fee Guide</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.label": {
    "overrideType": "FIELD_MAPPING",
    "customValue": "<p><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments</p>",
    "generatedValue": null,
    "mappedField": "property_bedrooms_range"
  },
  "floorplanslist.starting_at": {
    "overrideType": "VALUE",
    "customValue": "<p>Starting at $1,499</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Property Photos</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/lincoln-place-apartments-in-unit-laundry-loveland-co::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Experience the convenience of having in-unit laundry at Lincoln Place Apartments. Our Loveland, CO community offers modern living with top-notch amenities.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "_template:hyperlocal::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with In-Unit Laundry in Loveland, CO</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicycontent.body": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1><p>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.</p><h2><strong>Information We Collect</strong></h2><p>We collect information from visitors on our Web site through online requests including:</p><ul><li><p>Contact Requests</p></li><li><p>Schedule a Tour Requests</p></li></ul><p>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.</p><h2>How the Information is Used</h2><p>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. In addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.</p><h2><strong>Sharing of Personal Information</strong></h2><p>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.</p><h2><strong>Security</strong></h2><p>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.</p><h2><strong>Cookies</strong></h2><p>From time to time, we may send a \"cookie\" to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer's hard drive. A cookie can't read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.</p><h2><strong>Links to Outside Sites</strong></h2><p>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.</p><h2><strong>Removal from Our Mailing List</strong></h2><p>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.</p><h2><strong>Contacting Us</strong></h2><p>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At <span data-type=\"field-token\" data-field=\"property_name\"></span> in vibrant <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span>, our residents celebrate the sense of community and comfort we offer. Dive into our reviews and see what else our satisfied tenants have to say about life at <span data-type=\"field-token\" data-field=\"property_name\"></span>!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 10pt;\">Discover the features that make everyday living more convenient at Bull Mountain Heights Apartments in Tigard, OR. From spaces for recreation and relaxation to practical apartment features, our community offers a variety of amenities to complement our </span><a class=\"richtext-link\" href=\"https://www.bullmountainheights.com/floor-plans/\"><span style=\"font-size: 10pt;\"><u>one-, two-, and three-bedroom floor plans</u></span></a><span style=\"font-size: 10pt;\">.</span></p><p><span style=\"font-size: 10pt;\">Enjoy time outdoors at our swimming pool and hot tub, or stay active in our on-site fitness center. The clubhouse and TV lounge provide additional spaces to enjoy throughout the community, while a playground adds another outdoor amenity to the property. Bull Mountain Heights also offers package lockers for convenient deliveries and garages for additional parking options.</span></p><p><span style=\"font-size: 10pt;\">Inside your apartment, you'll find features designed with functionality in mind. Bull Mountain Heights apartment homes include an in-unit washer and dryer, private patio or balcony, ceiling fan, and fully equipped kitchen. Select apartments also feature fireplaces, vaulted ceilings, and skylights, allowing you to compare available homes based on the features you're looking for.</span></p><p><span style=\"font-size: 10pt;\">Want to get a closer look? Check out our </span><a class=\"richtext-link\" href=\"https://www.bullmountainheights.com/virtual-tour/\"><span style=\"font-size: 10pt;\"><u>virtual tours</u></span></a><span style=\"font-size: 10pt;\">!</span></p><p><span style=\"font-size: 10pt;\">Whether you're searching for Tigard apartments with a pool, apartments with a fitness center, or a community with convenient in-home features, explore the amenities available at Bull Mountain Heights.</span></p><p><span style=\"font-size: 10pt;\">Browse our one-, two-, and three-bedroom floor plans and current availability, or </span><a class=\"richtext-link\" href=\"https://www.bullmountainheights.com/contact-us/\"><span style=\"font-size: 10pt;\"><u>schedule a tour</u></span></a><span style=\"font-size: 10pt;\"> to experience the community amenities at Bull Mountain Heights in person.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 10pt;\">Have questions about availability, floor plans, amenities, or the leasing process? The team at Bull Mountain Heights Apartments in Tigard, OR is here to help you learn more about the community and find the information you need.</span></p><p><span style=\"font-size: 10pt;\">Bull Mountain Heights offers </span><a class=\"richtext-link\" href=\"https://www.bullmountainheights.com/floor-plans/\"><span style=\"font-size: 10pt;\"><u>one-, two-, and three-bedroom apartments</u></span></a><span style=\"font-size: 10pt;\"> for rent in Tigard, OR, with a variety of thoughtfully designed floor plans and convenient apartment features. Explore current availability, compare layouts, or reach out to learn more about pricing, lease options, community </span><a class=\"richtext-link\" href=\"https://www.bullmountainheights.com/amenities/\"><span style=\"font-size: 10pt;\"><u>amenities</u></span></a><span style=\"font-size: 10pt;\">, and scheduling a tour.</span></p><p><span style=\"font-size: 10pt;\">Use the contact form below to connect with our leasing team, or contact Bull Mountain Heights directly for assistance. We look forward to helping you explore your apartment options in Tigard.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 10pt;\">Find the space that works for you at Bull Mountain Heights Apartments in Tigard, OR. Our community offers a selection of one-, two-, and three-bedroom apartment floor plans with thoughtfully designed interiors and convenient features for everyday living. Whether you're looking for a one-bedroom layout or additional space in a two- or three-bedroom apartment, explore our available floor plans to compare layouts, square footage, pricing, and availability.</span></p><p><span style=\"font-size: 10pt;\">Each of our Tigard apartment floor plans includes features designed with comfort and functionality in mind. Enjoy a fully equipped kitchen, in-unit washer and dryer, ceiling fan, and a private patio or balcony. Select apartment homes also feature vaulted ceilings, fireplaces, and skylights, giving you even more options when choosing your next space.</span></p><p><span style=\"font-size: 10pt;\">If you're searching for 1, 2-, or 3-bedroom apartments in Tigard, OR, explore Bull Mountain Heights and find a floor plan that meets your needs. Browse current availability and pricing below, take a </span><a class=\"richtext-link\" href=\"/virtual-tour\"><span style=\"font-size: 10pt;\"><u>virtual tour</u></span></a><span style=\"font-size: 10pt;\">, or schedule an in-person tour to see our Tigard apartments for yourself.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 10pt;\">Take a closer look at Bull Mountain Heights and explore our gallery of Tigard, OR apartment photos. Browse images of our apartment interiors, community </span><a class=\"richtext-link\" href=\"https://www.bullmountainheights.com/amenities/\"><span style=\"font-size: 10pt;\"><u>amenities</u></span></a><span style=\"font-size: 10pt;\">, outdoor spaces, and property grounds to get a better feel for everything our community has to offer.</span></p><p><span style=\"font-size: 10pt;\">Inside our </span><a class=\"richtext-link\" href=\"https://www.bullmountainheights.com/floor-plans/\"><span style=\"font-size: 10pt;\"><u>apartments in Tigard, OR</u></span></a><span style=\"font-size: 10pt;\">, you'll find thoughtfully designed spaces with features that support comfortable everyday living. Browse photos of kitchens with stainless steel appliances, modern cabinetry, and updated countertops, along with open living areas, bedrooms, bathrooms, and in-unit washers and dryers. Select apartment homes also feature fireplaces and vaulted ceilings, while private patios or balconies provide additional space to enjoy outside.</span></p><p><span style=\"font-size: 10pt;\">Continue through the gallery to explore Bull Mountain Heights' community amenities. See our swimming pool and hot tub, fitness center with cardio and strength-training equipment, clubhouse and lounge areas, outdoor grilling and dining spaces, dog park, playground, and landscaped community grounds.</span></p><p><span style=\"font-size: 10pt;\">Our property photos make it easy to explore Bull Mountain Heights before visiting in person. After browsing the gallery, explore our </span><a class=\"richtext-link\" href=\"https://www.bullmountainheights.com/interactive-map/\"><span style=\"font-size: 10pt;\"><u>interactive map</u></span></a><span style=\"font-size: 10pt;\"> to see current availability, and check out our </span><a class=\"richtext-link\" href=\"https://www.bullmountainheights.com/virtual-tour/\"><span style=\"font-size: 10pt;\"><u>virtual tours</u></span></a><span style=\"font-size: 10pt;\"> to get an even closer look at our community.</span></p><p><span style=\"font-size: 10pt;\">Like what you see? Schedule a tour of Bull Mountain Heights and experience our apartments and community amenities in person.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 10pt;\">Find your next apartment at Bull Mountain Heights with our interactive apartment map in Tigard, OR. Explore our community online and view available apartment homes to help narrow down the location and floor plan that works for you.</span></p><p><span style=\"font-size: 10pt;\">Bull Mountain Heights offers a variety of one-, two-, and three-bedroom </span><a class=\"richtext-link\" href=\"https://www.bullmountainheights.com/floor-plans/\"><span style=\"font-size: 10pt;\"><u>apartments</u></span></a><span style=\"font-size: 10pt;\"> for rent in Tigard, OR, with floor plans ranging from approximately 607 to 1,178 square feet. Use the interactive map below to explore apartment locations throughout the community and view current pricing and availability.</span></p><p><span style=\"font-size: 10pt;\">Beyond our apartment homes, Bull Mountain Heights offers a variety of </span><a class=\"richtext-link\" href=\"https://www.bullmountainheights.com/amenities/\"><span style=\"font-size: 10pt;\"><u>community amenities</u></span></a><span style=\"font-size: 10pt;\">, including a swimming pool, hot tub, fitness center, clubhouse, TV lounge, playground, package lockers, and available garages. Apartment features include fully equipped kitchens, in-unit washers and dryers, ceiling fans, and private patios or balconies, with select homes offering additional features such as vaulted ceilings, fireplaces, and skylights.</span></p><p><span style=\"font-size: 10pt;\">Ready to start your apartment search? Explore the Bull Mountain Heights interactive community map below to find available apartments in Tigard, OR. Once you've found a floor plan or apartment home you're interested in, </span><a class=\"richtext-link\" href=\"https://www.bullmountainheights.com/contact-us/\"><span style=\"font-size: 10pt;\"><u>contact our leasing team</u></span></a><span style=\"font-size: 10pt;\"> to schedule a tour and take a closer look.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 10pt;\">Discover a convenient location near shopping, dining, parks, recreation, and everyday essentials at Bull Mountain Heights Apartments in Tigard, OR. Located on SW Bull Mountain Road, our community puts a variety of Tigard destinations within easy reach while also providing convenient access to Beaverton and the greater Portland area.</span></p><h3><span style=\"font-size: 13pt;\"><strong>Shopping &amp; Dining Near Bull Mountain Heights</strong></span></h3><p><span style=\"font-size: 10pt;\">Explore a variety of shopping and dining destinations throughout Tigard and the surrounding area. Progress Ridge TownSquare offers restaurants, shops, services, and entertainment near Progress Lake, while additional shopping options include Tigard Promenade, Tigard Plaza, Greenburg Road Shopping Center, Greenway Town Center, and Canterbury Square Shopping Center.</span></p><p><span style=\"font-size: 10pt;\">When you're looking for something to eat, the surrounding Tigard area offers plenty of choices. Local options include Malai Thai, Little Big Burger, Sanchez Taqueria Y Panaderia, Burgerville, and other restaurants throughout the Bull Mountain and Tigard area.</span></p><h3><span style=\"font-size: 13pt;\"><strong>Parks &amp; Recreation in Tigard, OR</strong></span></h3><p><span style=\"font-size: 10pt;\">Living at Bull Mountain Heights also puts several parks and recreational destinations nearby. Explore Bull Mountain Park, a 10-acre Tigard park featuring nature trails, a picnic shelter, playground, scenic viewpoint, and open spaces. Cook Park offers another nearby destination for spending time outdoors along the Tualatin River.</span></p><p><span style=\"font-size: 10pt;\">Near Progress Ridge TownSquare, Progress Lake Park features a quarry lake, paved trail, fishing access, and opportunities for walking and wildlife viewing. Other recreational destinations in the surrounding area include Pathfinder-Genesis Trail and King City Public Golf Course.</span></p><h3><span style=\"font-size: 13pt;\"><strong>Convenient Access Around Tigard</strong></span></h3><p><span style=\"font-size: 10pt;\">From Bull Mountain Heights, residents can reach destinations throughout Tigard, Beaverton, and the surrounding Portland metro area. Nearby major roadways help connect the Bull Mountain area with shopping, dining, employment centers, recreation, and other destinations throughout Washington County.</span></p><p><span style=\"font-size: 10pt;\">Whether you're searching for apartments in Tigard, OR, apartments near Progress Ridge, or a Tigard apartment with convenient access to Beaverton, Bull Mountain Heights puts you close to a variety of destinations for shopping, dining, recreation, and everyday needs.</span></p><p><span style=\"font-size: 10pt;\">Explore the neighborhood around Bull Mountain Heights, then browse our available one-, two-, and three-bedroom </span><a class=\"richtext-link\" href=\"https://www.bullmountainheights.com/floor-plans/\"><span style=\"font-size: 10pt;\"><u>floor plans</u></span></a><span style=\"font-size: 10pt;\"> to find your next apartment in Tigard, OR.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact leasing for details.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.stat_monthly_rent_value": {
    "overrideType": "VALUE",
    "customValue": "40",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.stat_pet_deposit_sublabel": {
    "overrideType": "VALUE",
    "customValue": "<p>(Refundable)</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 10pt;\">Discover comfortable, convenient living at Bull Mountain Heights Apartments in Tigard, OR. Our community offers spacious one-, two-, and three-bedroom </span><a class=\"richtext-link\" href=\"https://www.bullmountainheights.com/floor-plans/\"><span style=\"font-size: 10pt;\"><u>floor plans</u></span></a><span style=\"font-size: 10pt;\"> with features designed for everyday living. Select from thoughtfully designed apartment homes with fully equipped kitchens, stainless steel appliances, quartz countertops, walk-in closets, in-unit washer/dryer, and private bathrooms.</span></p><p><span style=\"font-size: 10pt;\">Beyond your front door, Bull Mountain Heights offers </span><a class=\"richtext-link\" href=\"/amenities\"><span style=\"font-size: 10pt;\"><u>community amenities</u></span></a><span style=\"font-size: 10pt;\"> that make it easy to relax, recharge, and enjoy your surroundings. Spend time by the swimming pool and hot tub, stay active in the fitness center, or enjoy the clubhouse and lounge spaces. Outdoor amenities include a playground, BBQ area and fire pit, a dog park, and convenient access to nearby walking and biking opportunities.</span></p><p><span style=\"font-size: 10pt;\">Our apartments in Tigard, OR also offer convenient features such as on-site management and maintenance. With a location on SW Bull Mountain Road, residents have convenient access to shopping, dining, recreation, and destinations throughout </span><a class=\"richtext-link\" href=\"https://www.bullmountainheights.com/neighborhood/\"><span style=\"font-size: 10pt;\"><u>Tigard and the surrounding Portland area</u></span></a><span style=\"font-size: 10pt;\">.</span></p><p><span style=\"font-size: 10pt;\">Find the space that fits your needs at Bull Mountain Heights. Explore our available one-, two-, and three-bedroom floor plans, browse our community amenities, or </span><a class=\"richtext-link\" href=\"https://www.bullmountainheights.com/contact-us/\"><span style=\"font-size: 10pt;\"><u>schedule a tour</u></span></a><span style=\"font-size: 10pt;\"> to experience apartments in Tigard, OR.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At Bull Mountain in Tigard, OR, we offer an array of thoughtfully designed floor plans, from cozy one-bedrooms to spacious three-bedrooms. Experience the vibrant community and stunning surroundings. Curious about life here? Schedule a tour today to envision your next home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 10pt;\">Explore Bull Mountain Heights from wherever you are with our virtual apartment tours in Tigard, OR. Take a closer look at our community, apartment interiors, and available spaces online before scheduling an in-person visit.</span></p><p><span style=\"font-size: 10pt;\">Bull Mountain Heights offers thoughtfully designed </span><a class=\"richtext-link\" href=\"https://www.bullmountainheights.com/floor-plans/\"><span style=\"font-size: 10pt;\"><u>one-, two-, and three-bedroom apartments in Tigard, OR</u></span></a><span style=\"font-size: 10pt;\">, with layouts created for comfortable and convenient everyday living. Our apartment homes feature modern finishes and practical details, including fully equipped kitchens, stainless steel appliances, quartz countertops, walk-in closets, and in-unit washers and dryers. Select apartment homes may also offer additional features and finishes.</span></p><p><span style=\"font-size: 10pt;\">Our virtual tour makes it easy to get a better sense of Bull Mountain Heights and what our community has to offer. Explore the property online, then browse our floor plans to compare layouts, current availability, and apartment features.</span></p><p><span style=\"font-size: 10pt;\">Ready to take a closer look? View the Bull Mountain Heights virtual tour below, then </span><a class=\"richtext-link\" href=\"https://www.bullmountainheights.com/contact-us/\"><span style=\"font-size: 10pt;\"><u>schedule an in-person tour</u></span></a><span style=\"font-size: 10pt;\"> to visit our apartments in Tigard, OR.</span></p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "<p><span data-type=\"field-token\" data-field=\"property_company_name\"></span> logo</p>"
      }
    }
  },
  "header.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "<p><span data-type=\"field-token\" data-field=\"property_name\"></span> logo, <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>"
      }
    }
  },
  "petpolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166803/01a0f8c9-221f-7498-be1f-ab85f7304521.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two adorable dogs relaxing on pillows on a cozy leather sofa indoors."
      }
    }
  },
  "accessibilityhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-d282-7562-8e11-5fb06fc48361.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Property office building with signage and playground in background"
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019fa50f-fef2-774a-a968-8fc9ce755d00.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A couple splashes water at each other in an outdoor swimming pool."
      }
    }
  },
  "applynowhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-98eb-744b-9354-ba78171c2873.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of apartment buildings with balconies under a blue sky with clouds."
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-d282-7562-8e11-5fb06fc48361.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Property office building with signage and playground in background"
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": 0,
    "fieldOverrides": null
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019fa50d-1ff2-7697-a4d5-281be26e6a07.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman petting a small dog on a cozy couch, enjoying a relaxing moment at home."
      }
    }
  },
  "floorplanshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-ce32-709c-97d3-d65782b4aa41.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious living room with a blue sectional sofa, two dark blue accent chairs, a fireplace, and a dining area."
      }
    }
  },
  "floorplanslist.card_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d2-2436-751d-a3fd-b5f4dd38258d.webp"
      }
    }
  },
  "floorplanslist.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d02d0-e8ab-7478-a098-cccd8381ed0f.webp"
      }
    }
  },
  "floorplanslist.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d48ab-c288-70cb-afca-f287a0ab97ed.webp"
      }
    }
  },
  "floorplanslist.card_viewall": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019d48ab-b155-743d-a925-4ad66a2950d4.webp"
      }
    }
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-4246-767d-805b-e2b734421cdc.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of apartment complex amenities including a pool, playground, and outdoor seating area."
      }
    }
  },
  "interactivemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-320f-713f-8c34-d83d111a930a.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a multifamily property with multiple buildings, a swimming pool, a playground, and mature trees."
      }
    }
  },
  "neighborhoodcallout.image_1": {
    "sourceIndex": 11,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-7f5e-7545-a671-19cebc75d7c9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of apartment buildings and surrounding landscape."
      }
    }
  },
  "neighborhoodcallout.image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019fa50f-3d72-7626-b6e5-6a1854d3a9e3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman relaxing in a swimming pool."
      }
    }
  },
  "neighborhoodcallout.image_3": {
    "sourceIndex": 7,
    "fieldOverrides": null
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-3b17-773f-b4e4-b96e53e8cb6b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a tan apartment building with multiple balconies and large trees."
      }
    }
  },
  "privacypolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-3b17-773f-b4e4-b96e53e8cb6b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of a tan Bull Mountain Heights apartment building surrounded by mature trees under a blue sky."
      }
    }
  },
  "propertyoverview.lifestyle_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019fa50d-1ff2-7697-a4d5-281be26e6a07.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman petting a small dog on her lap while sitting on a couch with a red blanket."
      }
    }
  },
  "propertyoverview.lifestyle_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/01a0fdfa-8571-7056-bcc4-84acf6f5bbc1.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Two friends relaxing on unicorn and pineapple floats in a sunny pool."
      }
    }
  },
  "propertyoverview.slide_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-df94-752a-8fd8-6ddd43f86ac9.webp"
      }
    }
  },
  "propertyoverview.slide_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-f89f-7038-8ae4-11a96ac20861.webp"
      }
    }
  },
  "propertyoverview.slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-98eb-744b-9354-ba78171c2873.webp"
      }
    }
  },
  "propertyoverview.slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-42c0-7191-a33c-da25dd637e53.webp"
      }
    }
  },
  "propertyoverview.slide_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-cfb2-72ce-98ab-60f3d1a8a0d4.webp"
      }
    }
  },
  "propertyoverview.slide_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-7e79-70ce-a8ad-c2df85bffed3.webp"
      }
    }
  },
  "propertyoverview.slide_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3882-ce32-709c-97d3-d65782b4aa41.webp"
      }
    }
  },
  "propertyoverview.slide_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-2c57-7286-a50d-11f5e7e36dab.webp"
      }
    }
  },
  "residentaccesshero.bg_image": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "reviewshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166802/019fa50d-e65c-73ce-9995-1d7372d20f71.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two residents enjoying a sunny day in the Bull Mountain Heights community pool."
      }
    }
  },
  "scheduleatourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-193a-764a-b8b1-77ff6a61f865.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Apartment complex office building at dusk with playground nearby."
      }
    }
  },
  "sitemaphero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166802/019f3883-3b17-773f-b4e4-b96e53e8cb6b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a tan apartment building with multiple balconies and large trees."
      }
    }
  },
  "thankyouhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166802/019fa50d-e65c-73ce-9995-1d7372d20f71.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Two young women enjoy a sunny day swimming in a community pool."
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": 21,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": 6,
    "hiddenIds": [
      "custom_2d78a66b-9005-4718-be9a-4a9c158cc330"
    ],
    "orderedIds": [
      "custom_b1ee0e0c-29b8-4438-889d-70d5ad26e119",
      "custom_fc4b35ee-c3b8-4d7b-aed2-4b9fe48c5454",
      "custom_af94ee3c-2565-4c38-85fd-6e997fbf8d44",
      "custom_eadfbac9-1194-4d6c-957c-016fd48261a4",
      "custom_7d8c008c-88e2-4bd0-90e1-a96ed0cf2a50",
      "custom_b68f9a9c-dc54-4d84-95c7-45d8c52dae4a",
      "custom_ba74768b-6bac-4363-baa9-d8ac961dd155",
      "custom_82534707-c078-4d62-b7cc-fb05b99a8b9e",
      "custom_85287de4-270d-46d1-b4aa-f1def3bd69fe",
      "custom_59f1d04d-3afa-475a-89d1-dc1f34e1ed43",
      "custom_9943db45-ab0b-4375-a3bc-401d8b7fc037",
      "custom_b2d3727f-8ed9-45c6-a84b-f1c6d913f586",
      "custom_d8fe03a9-be22-4f6e-8a77-c1aabe41e129",
      "custom_d099aad0-754a-4e1e-a175-e97c3fdfbaca",
      "custom_1d135a43-5b38-4597-9183-e5d0975765e6",
      "custom_29d33015-ac2c-408b-9675-31c4731b6b59",
      "custom_25292dab-6ee2-499c-a20e-6c965dc7ce0c",
      "custom_2f7696e4-73a4-431e-a20f-a04cca2fea20",
      "custom_16c8f207-7034-45b9-ac20-c930e7cc7126",
      "custom_4c684daf-6ab2-41f8-9ce4-7a04e0b58b4a",
      "custom_b32af202-5609-4b19-bfa1-faba38d30bfa",
      "custom_f50ede8a-939f-4262-a9a7-d068de6112f2",
      "custom_de4b9e31-3504-4964-9e89-1be2b407ed33",
      "custom_f18f09b2-8cc0-41f6-a9d4-a7afcb0fb4f4",
      "custom_0c173967-cc67-4cf5-abd3-3ad2b483e03b",
      "custom_a78ecc20-f985-4212-b33e-5c3a94f1b8d1",
      "custom_befbf532-18c4-40dd-8864-c639d991660b",
      "custom_e879b018-153c-4269-8ee1-ea04819ebbed",
      "custom_1c1ed6ee-a1b0-4980-90b2-676ced8d703f",
      "custom_6763087c-4b41-4c87-bcdf-6ad31bf374fb",
      "custom_7fa525d3-7c0d-4330-9f94-910cb84c1a8c",
      "custom_b62524b2-156a-43da-b4cc-57eb13736424",
      "custom_f1e89305-6597-4ab3-8beb-bb2814707558",
      "custom_e4f2a448-b890-42f4-9a2c-ed57d291f14f",
      "custom_cd24963e-f845-41da-af90-2310b4bd9615",
      "custom_8637d7a3-b201-414a-a52c-f024a3b69f5c",
      "custom_e62e191c-f5d9-487e-b1f2-f20fb0e080b9",
      "custom_69bc2502-bd9e-43b9-aca4-c9c5c4a7d23b",
      "custom_5614a279-97d9-4e80-abf6-a40cb1dc4f6d",
      "custom_d0b3d7f7-b2d9-475f-8398-bc3ecfe13099",
      "custom_c420331a-a5f5-463a-8eba-04c8dd35b641",
      "custom_abaeee63-99eb-4653-bd3f-506e27dfb873",
      "custom_b1f5cfc8-c912-4cc7-b8db-0cc7f22dcc59",
      "custom_104e1d25-1e5a-48dd-9163-2508e4080af4",
      "custom_16029871-e063-41c1-b5af-5ce32d999cd8",
      "custom_c44180f1-2398-4209-b992-22a6b8a9d7b2",
      "custom_5eb8c9c6-42ea-4302-82a7-00943280c58b",
      "custom_31c2b238-8aed-4552-bb2a-302c2f58f3c0",
      "custom_73cefc5c-cadd-41bf-a880-7fc5f6c14032",
      "custom_f4925142-c537-41e7-bf9f-0b4cedf28eca",
      "custom_ea229888-c189-4899-8f9e-4032ce21a4d5",
      "custom_9983de5a-7ed9-49a9-b12b-494610130ff5",
      "custom_b1a35fb8-70d7-49fc-8942-d0b0ab02c96a",
      "custom_97ce2ac5-f60c-408e-bf35-e355dfb36028",
      "custom_8d161070-8826-4e9f-b5ee-067a25cae1cc",
      "custom_ce6a97e8-de0e-4af4-b1a4-72c80098c752",
      "custom_268e0f68-80f5-4b9e-8afb-1de688303196",
      "custom_2894c4bf-07b4-46d7-b433-e569ee9587c9",
      "custom_27b6f9bb-8ab7-4140-bcd7-d6ff68062d5b"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.apartmentPhotos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_eadfbac9-1194-4d6c-957c-016fd48261a4",
      "custom_6bccf692-389a-456b-b752-19993404d952",
      "custom_25292dab-6ee2-499c-a20e-6c965dc7ce0c",
      "custom_b36d78f8-547c-48fc-9aca-85150894c24f",
      "custom_ba74768b-6bac-4363-baa9-d8ac961dd155",
      "custom_1d135a43-5b38-4597-9183-e5d0975765e6",
      "custom_2f7696e4-73a4-431e-a20f-a04cca2fea20",
      "custom_8250fa06-1996-485b-b09a-057072561229",
      "custom_b1ee0e0c-29b8-4438-889d-70d5ad26e119",
      "custom_4c684daf-6ab2-41f8-9ce4-7a04e0b58b4a",
      "custom_ec51afc6-42c0-42ab-ac88-11f4c90e8379",
      "custom_f50ede8a-939f-4262-a9a7-d068de6112f2",
      "custom_a0c0b233-d57e-4cce-bfad-0ea8fe00c4b1",
      "custom_de4b9e31-3504-4964-9e89-1be2b407ed33",
      "custom_0c173967-cc67-4cf5-abd3-3ad2b483e03b",
      "custom_a78ecc20-f985-4212-b33e-5c3a94f1b8d1",
      "custom_d099aad0-754a-4e1e-a175-e97c3fdfbaca",
      "custom_e879b018-153c-4269-8ee1-ea04819ebbed",
      "custom_6763087c-4b41-4c87-bcdf-6ad31bf374fb",
      "custom_f1e89305-6597-4ab3-8beb-bb2814707558",
      "custom_8637d7a3-b201-414a-a52c-f024a3b69f5c",
      "custom_e62e191c-f5d9-487e-b1f2-f20fb0e080b9",
      "custom_54600fec-18a9-4b22-8160-46286e0ca45b",
      "custom_69bc2502-bd9e-43b9-aca4-c9c5c4a7d23b",
      "custom_9943db45-ab0b-4375-a3bc-401d8b7fc037",
      "custom_8981620c-edf5-4cac-9ab6-6cf83b48566f",
      "custom_d90a45bd-db90-4b3f-b89a-13fcacdb1c5e",
      "custom_b1f5cfc8-c912-4cc7-b8db-0cc7f22dcc59",
      "custom_ef33c844-2e03-49e4-a3ee-18a060402e56",
      "custom_104e1d25-1e5a-48dd-9163-2508e4080af4",
      "custom_16029871-e063-41c1-b5af-5ce32d999cd8",
      "custom_fc56040a-3d3c-4670-87cd-eb18c265b5d8",
      "custom_5eb8c9c6-42ea-4302-82a7-00943280c58b",
      "custom_0a05a220-53c4-44b0-96f6-afd95d619601",
      "custom_ca2cf73f-d52f-4cc2-893c-203daf00b6b2",
      "custom_1e44cef7-67cd-40e3-8dd9-9150ba465d37",
      "custom_97ce2ac5-f60c-408e-bf35-e355dfb36028",
      "custom_ce6a97e8-de0e-4af4-b1a4-72c80098c752",
      "custom_268e0f68-80f5-4b9e-8afb-1de688303196"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "custom_7d8c008c-88e2-4bd0-90e1-a96ed0cf2a50",
      "custom_85287de4-270d-46d1-b4aa-f1def3bd69fe",
      "custom_b68f9a9c-dc54-4d84-95c7-45d8c52dae4a",
      "custom_29d33015-ac2c-408b-9675-31c4731b6b59",
      "custom_16c8f207-7034-45b9-ac20-c930e7cc7126",
      "custom_ade27883-7fff-4de4-89c5-317ec2aab07a",
      "custom_fc4b35ee-c3b8-4d7b-aed2-4b9fe48c5454",
      "custom_d8fe03a9-be22-4f6e-8a77-c1aabe41e129",
      "custom_b2d3727f-8ed9-45c6-a84b-f1c6d913f586",
      "custom_b32af202-5609-4b19-bfa1-faba38d30bfa",
      "custom_82534707-c078-4d62-b7cc-fb05b99a8b9e",
      "custom_f18f09b2-8cc0-41f6-a9d4-a7afcb0fb4f4",
      "custom_befbf532-18c4-40dd-8864-c639d991660b",
      "custom_3f5c4705-42d2-4d63-a417-1cad42ca95ac",
      "custom_1c1ed6ee-a1b0-4980-90b2-676ced8d703f",
      "custom_7fa525d3-7c0d-4330-9f94-910cb84c1a8c",
      "custom_b62524b2-156a-43da-b4cc-57eb13736424",
      "custom_e4f2a448-b890-42f4-9a2c-ed57d291f14f",
      "custom_cd24963e-f845-41da-af90-2310b4bd9615",
      "custom_5614a279-97d9-4e80-abf6-a40cb1dc4f6d",
      "custom_d0b3d7f7-b2d9-475f-8398-bc3ecfe13099",
      "custom_c420331a-a5f5-463a-8eba-04c8dd35b641",
      "custom_cbeecd7c-d484-420c-9567-aa731928e425",
      "custom_abaeee63-99eb-4653-bd3f-506e27dfb873",
      "custom_59f1d04d-3afa-475a-89d1-dc1f34e1ed43",
      "custom_c44180f1-2398-4209-b992-22a6b8a9d7b2",
      "custom_31c2b238-8aed-4552-bb2a-302c2f58f3c0",
      "custom_73cefc5c-cadd-41bf-a880-7fc5f6c14032",
      "custom_af94ee3c-2565-4c38-85fd-6e997fbf8d44",
      "custom_f4925142-c537-41e7-bf9f-0b4cedf28eca",
      "custom_ea229888-c189-4899-8f9e-4032ce21a4d5",
      "custom_9983de5a-7ed9-49a9-b12b-494610130ff5",
      "custom_b1a35fb8-70d7-49fc-8942-d0b0ab02c96a",
      "custom_8d161070-8826-4e9f-b5ee-067a25cae1cc",
      "custom_2894c4bf-07b4-46d7-b433-e569ee9587c9",
      "custom_27b6f9bb-8ab7-4140-bcd7-d6ff68062d5b"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": [
      "custom_b32af202-5609-4b19-bfa1-faba38d30bfa",
      "custom_abaeee63-99eb-4653-bd3f-506e27dfb873",
      "custom_16c8f207-7034-45b9-ac20-c930e7cc7126",
      "custom_e4f2a448-b890-42f4-9a2c-ed57d291f14f",
      "custom_7d8c008c-88e2-4bd0-90e1-a96ed0cf2a50",
      "custom_b2d3727f-8ed9-45c6-a84b-f1c6d913f586",
      "custom_c420331a-a5f5-463a-8eba-04c8dd35b641",
      "custom_7fa525d3-7c0d-4330-9f94-910cb84c1a8c",
      "custom_d0b3d7f7-b2d9-475f-8398-bc3ecfe13099",
      "custom_8637d7a3-b201-414a-a52c-f024a3b69f5c",
      "custom_a78ecc20-f985-4212-b33e-5c3a94f1b8d1",
      "custom_ce6a97e8-de0e-4af4-b1a4-72c80098c752",
      "custom_2f7696e4-73a4-431e-a20f-a04cca2fea20",
      "custom_6763087c-4b41-4c87-bcdf-6ad31bf374fb",
      "custom_b1ee0e0c-29b8-4438-889d-70d5ad26e119",
      "custom_eadfbac9-1194-4d6c-957c-016fd48261a4",
      "custom_4c684daf-6ab2-41f8-9ce4-7a04e0b58b4a",
      "custom_69bc2502-bd9e-43b9-aca4-c9c5c4a7d23b",
      "custom_e62e191c-f5d9-487e-b1f2-f20fb0e080b9"
    ],
    "orderedIds": [
      "custom_82534707-c078-4d62-b7cc-fb05b99a8b9e",
      "custom_8d161070-8826-4e9f-b5ee-067a25cae1cc",
      "custom_b1a35fb8-70d7-49fc-8942-d0b0ab02c96a",
      "custom_b62524b2-156a-43da-b4cc-57eb13736424",
      "custom_befbf532-18c4-40dd-8864-c639d991660b",
      "custom_c44180f1-2398-4209-b992-22a6b8a9d7b2",
      "custom_cd24963e-f845-41da-af90-2310b4bd9615",
      "custom_b2d3727f-8ed9-45c6-a84b-f1c6d913f586",
      "custom_d0b3d7f7-b2d9-475f-8398-bc3ecfe13099",
      "custom_2894c4bf-07b4-46d7-b433-e569ee9587c9",
      "custom_5614a279-97d9-4e80-abf6-a40cb1dc4f6d",
      "custom_d8fe03a9-be22-4f6e-8a77-c1aabe41e129",
      "custom_27b6f9bb-8ab7-4140-bcd7-d6ff68062d5b",
      "custom_f4925142-c537-41e7-bf9f-0b4cedf28eca",
      "custom_73cefc5c-cadd-41bf-a880-7fc5f6c14032",
      "custom_85287de4-270d-46d1-b4aa-f1def3bd69fe",
      "custom_9983de5a-7ed9-49a9-b12b-494610130ff5",
      "custom_ea229888-c189-4899-8f9e-4032ce21a4d5",
      "custom_31c2b238-8aed-4552-bb2a-302c2f58f3c0",
      "custom_29d33015-ac2c-408b-9675-31c4731b6b59",
      "custom_16029871-e063-41c1-b5af-5ce32d999cd8",
      "custom_fc4b35ee-c3b8-4d7b-aed2-4b9fe48c5454",
      "custom_59f1d04d-3afa-475a-89d1-dc1f34e1ed43",
      "custom_af94ee3c-2565-4c38-85fd-6e997fbf8d44",
      "custom_1c1ed6ee-a1b0-4980-90b2-676ced8d703f",
      "custom_f18f09b2-8cc0-41f6-a9d4-a7afcb0fb4f4",
      "custom_b68f9a9c-dc54-4d84-95c7-45d8c52dae4a",
      "custom_7fa525d3-7c0d-4330-9f94-910cb84c1a8c",
      "custom_c420331a-a5f5-463a-8eba-04c8dd35b641",
      "custom_7d8c008c-88e2-4bd0-90e1-a96ed0cf2a50",
      "custom_e4f2a448-b890-42f4-9a2c-ed57d291f14f",
      "custom_16c8f207-7034-45b9-ac20-c930e7cc7126",
      "custom_abaeee63-99eb-4653-bd3f-506e27dfb873",
      "custom_b32af202-5609-4b19-bfa1-faba38d30bfa",
      "custom_104e1d25-1e5a-48dd-9163-2508e4080af4",
      "custom_b1ee0e0c-29b8-4438-889d-70d5ad26e119",
      "custom_de4b9e31-3504-4964-9e89-1be2b407ed33",
      "custom_eadfbac9-1194-4d6c-957c-016fd48261a4",
      "custom_b1f5cfc8-c912-4cc7-b8db-0cc7f22dcc59",
      "custom_1d135a43-5b38-4597-9183-e5d0975765e6",
      "custom_ba74768b-6bac-4363-baa9-d8ac961dd155",
      "custom_6763087c-4b41-4c87-bcdf-6ad31bf374fb",
      "custom_f1e89305-6597-4ab3-8beb-bb2814707558",
      "custom_2f7696e4-73a4-431e-a20f-a04cca2fea20",
      "custom_f50ede8a-939f-4262-a9a7-d068de6112f2",
      "custom_9943db45-ab0b-4375-a3bc-401d8b7fc037",
      "custom_268e0f68-80f5-4b9e-8afb-1de688303196",
      "custom_ce6a97e8-de0e-4af4-b1a4-72c80098c752",
      "custom_e879b018-153c-4269-8ee1-ea04819ebbed",
      "custom_a78ecc20-f985-4212-b33e-5c3a94f1b8d1",
      "custom_97ce2ac5-f60c-408e-bf35-e355dfb36028",
      "custom_25292dab-6ee2-499c-a20e-6c965dc7ce0c",
      "custom_8637d7a3-b201-414a-a52c-f024a3b69f5c",
      "custom_0c173967-cc67-4cf5-abd3-3ad2b483e03b",
      "custom_5eb8c9c6-42ea-4302-82a7-00943280c58b",
      "custom_4c684daf-6ab2-41f8-9ce4-7a04e0b58b4a",
      "custom_e62e191c-f5d9-487e-b1f2-f20fb0e080b9",
      "custom_d099aad0-754a-4e1e-a175-e97c3fdfbaca",
      "custom_69bc2502-bd9e-43b9-aca4-c9c5c4a7d23b"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "anyonehome-chatbot",
      "blockId": "anyonehome-chatbot",
      "position": 0
    },
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    }
  ],
  "interactive-map": [
    {
      "sectionId": "engrain-sitemap",
      "blockId": "engrain-sitemap",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  }
};
